import React, { Component } from 'react'
import { Button, Table, Modal, Divider, Popconfirm, Spin, message, Form, Input } from "antd"
import styled from "styled-components"
import UserForm from '@/components/User/UserForm'
import UserAPI from '@/API/user'
import RoleAPI from '@/API/role'
import OperatorAPI from '@/API/operator'
import dayjs from 'dayjs'
import { setRoles } from '@/store/actionCreators'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';

const ButtonContainer=styled.div`
  padding: 20px;
`

const UserTable=styled(Table)`
  margin:0 20px;
`

class User extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      userList:[],
      searchKey:'',
      operatorCodeList:[],
      loading:false,
      modalType:'add',
      modalShow:false,
      confirmLoading:false,
      formUser:{
        userName:'',
        email:'',
        phoneNumber:'',
        operator:'',
        roleId:null
      },
      pagination:{
        current:1,
        pageSize:10,
        total:0,
        showSizeChanger:true,
        size:'small',
        showTotal:(total)=>(this.props.t('Total items',{total:total}))
      }
    };
  }
  findRole(id){
    let role=this.props.roles.find((role)=>{
      console.log(role)
      return role.id===id
    })
    return role?role.name:id
  }

  componentDidMount() {
    this.getUserList()
    this.getRoleList()
    this.getOperatorList()
  }
  
  getRoleList=()=>{
    if(!this.props.roles.length){
      RoleAPI.getRoleList({pageIndex:0,pageSize:-1}).then((res)=>{
        if(!res){
          return
        }
        console.log(res.roles)
        this.props.setRoles(res.roles)
      })
    }
  }
  getUserList=()=>{
    this.setState({loading:true})
    let pagination=this.state.pagination
    UserAPI.getUserList({key:this.state.searchKey,pageIndex:pagination.current-1,pageSize:pagination.pageSize}).then((res)=>{
      this.setState((state)=>{
        return {userList:res.users,pagination:{...state.pagination,total:res.totalCount}}
      })
      this.setState({loading:false})
    })
  }
  getOperatorList=()=>{
    OperatorAPI.getOperatorCodeList().then((res)=>{
      if(!res.code){
        this.setState({operatorCodeList:res})
      }
    })
  }
  handleFormChange = (changedFields) => {
    this.setState(({ formUser }) => {
      return {
        formUser: { ...formUser, ...changedFields }
      }
    })
  }
  handleTableChange=(pagination)=>{
    this.setState({
      pagination: pagination,
    },()=>{
      this.getUserList()
    });
  }
  initAdd=()=>{
    this.setState({
      modalType:'add',
      modalShow:true,
      formUser:{
        userName:'',
        email:'',
        phoneNumber:'',
        operator:'',
        roleId:null
      }
    })
  }
  initEdit=(user)=>{
    //debugger
    this.setState({
      modalType:'edit',
      modalShow:true,
      formUser:user
    })
  }
  // 删除用户功能
  deleteUser(user){
    UserAPI.deleteUser({userName:user.userName}).then((res)=>{
      if(!res.code){
        message.success(this.props.t('Deleted successfully.'))
        this.getUserList()
      }
    })
  }
  // 添加用户功能
  addUser(user){        
    this.setState({confirmLoading:true})
    UserAPI.addUser(user).then((res)=>{
      if(!res.code){
        this.hideModal()
        message.success(this.props.t('Added successfully.'))
        this.getUserList()
      }
      this.setState({confirmLoading:false})
    }).catch(()=>{
      this.setState({confirmLoading:false})
    })
  }
  // 修改用户信息
  editUser(user){
    this.setState({confirmLoading:true})
    UserAPI.editUser(user).then((res)=>{
      if(!res.code){
        this.hideModal()
        message.success(this.props.t('Edited successfully.'))
        this.getUserList()
      }
      this.setState({confirmLoading:false})
    }).catch(()=>{
      this.setState({confirmLoading:false})
    })
  }
  hideModal(){
    this.setState({modalShow:false})
  }
  handleOk=()=>{
    const form=this.formRef.props.form
    form.validateFields((err,values)=>{
      if(err){
        return
      }
      if(this.state.modalType==='add'){
        this.addUser(values)
      }else{
        this.editUser(values)
      }
    })
  }
  handleCancel=()=>{
    this.hideModal()
  }
  saveFormRef=(formRef)=>{
    this.formRef=formRef
  }
  onChange=(e)=>{
    this.setState({searchKey:e.target.value})
  }
  render() {
    const {userList,loading,pagination,modalType,modalShow,confirmLoading,formUser,operatorCodeList}=this.state
    const { t, roleId } = this.props;
    const columns=[
      {
        title:this.props.t('Username'),
        dataIndex:'userName',
        key:'userName'
      },
      {
        title:this.props.t('Creation Time'),
        dataIndex:'createTime',
        key:'createTime',
        render:function(text){
          return dayjs(text).format('YYYY-MM-DD HH:mm:ss')
        }
      },
      {
        title:this.props.t('Email'),
        dataIndex:'email',
        key:'email'
      },
      {
        title:this.props.t('Phone Number'),
        dataIndex:'phoneNumber',
        key:'phoneNumber'
      },
      {
        title:this.props.t('Carrier Code'),
        dataIndex:'operator',
        key:'operator'
      },
      {
        title:this.props.t('Role'),
        render:(text,record)=>(
          <span>
            {
              this.findRole(record.roleId)
            }
          </span>
        )
      },
      {
        title:this.props.t('Creator'),
        dataIndex:'creator',
        key:'creator'
      },
      {
        title:this.props.t('Operation'),
        width:150,
        align:'center',
        render:(text,record)=>(
          <span>
            <a onClick={()=>this.initEdit(record)}>{this.props.t('Edit')}</a>
            {
              roleId!==4 && (
                <span>
                  <Divider type="vertical" />
                  <Popconfirm title={this.props.t('Delete the user?')} okType="danger" onConfirm={()=>this.deleteUser(record)}>
                    <a>{this.props.t('Delete')}</a>
                  </Popconfirm>
                </span>
              )
            }
          </span>
        )
      }
    ]
    return (
      <div>
        {
          roleId!==4 && (
            <ButtonContainer>
              <Form layout="inline">
                <Form.Item label={t('Username')}>
                  <Input allowClear onChange={this.onChange}></Input>
                </Form.Item>
                <Form.Item>
                  <Button onClick={this.getUserList}>{t('Search')}</Button>
                </Form.Item>
                <Form.Item>
                  <Button type="primary" onClick={this.initAdd}>{t('Add User')}</Button>
                </Form.Item>
              </Form>
            </ButtonContainer>
          )
        }
        <Spin spinning={loading}>
          <UserTable dataSource={userList} columns={columns} pagination={pagination} rowKey="userName" onChange={this.handleTableChange}></UserTable>
        </Spin>
        {
          modalShow&&(
            <Modal maskClosable={false} title={modalType==='add'?t('Add User'):t('Edit User')} visible={modalShow} onOk={this.handleOk} confirmLoading={confirmLoading} onCancel={this.handleCancel}>
              <UserForm wrappedComponentRef={this.saveFormRef} user={formUser} operatorCodeList={operatorCodeList} onChange={this.handleFormChange} title={modalType}></UserForm>
            </Modal>
          )
        }
      </div>
    )
  }
}

const mapStateToProps = (state)=>{
  return {
    roles:state.roles,
    roleId:state.roleId
  }
}

const mapDispatchToProps = { setRoles }

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(User))
